export default __webpack_public_path__ + "locales/tr/SMTPSettings.json?hash=b4d39da8301e14eac21586994972877b";